import { Box } from "@mui/material"
import CircularIndeterminate from "components/blocks/progressBar/progressBar"
import { AppContext } from "contexts/AppContext"
import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"

const ShopRedirect = () => {
    const navigate = useNavigate()
    const { accessibleShops } = useContext(AppContext)

    useEffect(() => {
        if(accessibleShops.length) {
            const ShopID = accessibleShops[0].ShopID
            navigate(`/shop/${ShopID}`)
        }
    }, [accessibleShops])

    return (
        <Box marginTop={4} display={'flex'} flex={1} justifyContent={'center'} >
            <CircularIndeterminate />
        </Box>
    )
}

export default ShopRedirect